import { FISH_TYPES, FISH_MARKET, FISH_RESERVATIONS, FISH_RESERVATIONS_LOG, FISH_ADDED } from '../constants'
import { appLoading, appMessage } from './appActions'
import moment from 'moment/min/moment-with-locales'
import { DB } from '../firebase'


export const getFishTypes = () => dispatch => new Promise(resolve => {
  DB.collection('fishTypes')
  .onSnapshot(result => {
    result = result.docs.map(r => ({ ...r.data(), id: r.id }))
    dispatch({ type: FISH_TYPES, payload: result })
    resolve(true);
  })
})

export const getFishMarket = (limit=100) => dispatch => new Promise(resolve => {
  let startTime = new Date()
  startTime.setHours(startTime.getHours() - 7 );
  startTime.setDate(startTime.getDate())
  DB.collection('fishMarket')
  .where("time", ">=", startTime)
  .limit(limit)
  .orderBy("time")
  .onSnapshot(result => {
    result = result.docs.map(r => r.data())
    result = result.filter(r => {
        if( r.timeOnMarket && (r.time.seconds*1000 + r.timeOnMarket*3600*1000) < Date.now() ) return false
        return true
    })

    dispatch({ type: FISH_MARKET, payload: result })
    resolve(true);
  })
})

//no getFishReservationsFromDb() because of listener needed
export const getFishReservations = () => dispatch => {
  const currentTime = new Date()
  DB.collection('fishReservation')
    .where("active", "==", true)
    .where("expirationTime", ">", currentTime)
    .onSnapshot( async response => {
      let reservations = response.docs.map( r => ({ reservationId: r.ref.id, ...r.data() }) )
      dispatch({ type: FISH_RESERVATIONS, payload: reservations })
    })
}

export const getFishReservationsLog = () => dispatch => {
  let customTime = new Date()
  customTime.setDate(customTime.getDate() - 30)
  DB.collection('fishReservationLog')
    .where("time", ">", customTime)
    .onSnapshot( async response => {
      let log = response.docs.map( r => ({ logId: r.ref.id, ...r.data() }) )
      dispatch({ type: FISH_RESERVATIONS_LOG, payload: log })
    })
}


export const getFishReservationsFromDb = () => {
  const currentTime = new Date()
  return DB.collection('fishReservation')
    .where("active", "==", true)
    .where("expirationTime", ">", currentTime)
    .get()
    .then( response => {
      return response.docs.map( r => {
        const reservationId = r.ref.id
        return { ...r.data(), reservationId }
      })
    })
    .catch(e => {
      return {}
    })
}

const deteleReservation = reservationId => {
  return DB.collection('fishReservation').doc(reservationId).update({active: false})
}

const addReservationLog = fishLog => {
  const { reservation, newAddedFish, message } = fishLog
  const logToDb = {
    reservationPrice: reservation.price,
    fisherPrice: newAddedFish.price,
    reservationAmount: reservation.amount,
    fisherAmount: newAddedFish.newAddedFishAmount,
    fishType: reservation.fishType,
    fisherId: newAddedFish.fisherId,
    message: message,
    reservationId: reservation.reservationId,
    restaurantId: reservation.restaurantId,
    time: new Date()
  }
  return DB.collection('fishReservationLog').add(logToDb)
}

export const getRestaurantDetail = (restaurantId) => {
  return DB.collection('users').doc(restaurantId).get()
          .then(r => r.data())
}

const checkReservationsToThisFish = async(newAddedFish) => {
  let message
  let currentReservation = await getFishReservationsFromDb()
  for( let r of currentReservation) {
    if( r.fishType===newAddedFish.fishType && newAddedFish.amount>=r.amount && moment(newAddedFish.time).format('X')<=r.expirationTime.seconds && newAddedFish.price<=r.price ) {
      await deteleReservation(r.reservationId)

      let restaurantDetail = await getRestaurantDetail(r.restaurantId)
      const newAddedFishAmount = newAddedFish.amount
      newAddedFish.amount -= r.amount
      if( !newAddedFish.amount ) {
        message = `Uwaga: cała ilość (${r.amount}) dodanej ryby pasowała do zamówienia restauracji ${restaurantDetail.name}. `
        await addReservationLog({ ...{reservation: r}, ...{ newAddedFish: { ...newAddedFish, newAddedFishAmount }}, ...{message} })
        return { newAddedFish: null, message: message}
      } else {
        message = `Uwaga: część dodanej ryby pasowała do zamówienia restauracji ${restaurantDetail.name}. Do restauracji trafiło ${r.amount}, na targ trafiło ${newAddedFish.amount}`
        await addReservationLog({ ...{reservation: r}, ...{newAddedFish: { ...newAddedFish, newAddedFishAmount}}, ...{message} })
        return { newAddedFish: newAddedFish, message: message}
      }
    }
  }

  //if nothing, return this fish
  return newAddedFish
}

export const addFishToMarket = (fishObj) => async(dispatch) => {
  let message
  dispatch(appLoading(true))
  
  fishObj = await checkReservationsToThisFish(fishObj)
  //new object contains message or just fish object
  if( typeof fishObj === "object" && fishObj.message ) {
    message = fishObj.message
    fishObj = fishObj.newAddedFish
  } else {
    message = 'Ryba została dodana'
  }

  if( fishObj === null ) {
    dispatch(appMessage(message))
    return
  }
  
  DB.collection('fishMarket').add(fishObj)
    .then( () => {
      dispatch(appMessage(message))
    })
    .catch( () => {
      dispatch(appMessage('Wystąpił błąd, spróbuj raz jeszcze'))
    })
}

export const editFishOnMarket = (fishObj) => dispatch => {
  dispatch(appLoading(true))
  DB.collection('fishMarket').doc(fishObj.id).set(fishObj)
    .then( () => {
      dispatch(appMessage('{goToAddedFishList}'))
    })
    .catch( (e) => {
      dispatch(appMessage('Wystąpił błąd, spróbuj raz jeszcze',e))
    })
}


export const addFishReservation = (fishObj) => dispatch => {
  dispatch(appLoading(true))
  DB.collection('fishReservation').add(fishObj)
    .then( () => {
      dispatch(appMessage('Zamówienie zostało dodane'))
    })
    .catch( e => {
      dispatch(appMessage('Wystąpił błąd, spróbuj raz jeszcze'))
    })
}



export const updateFishData = fishData => async(dispatch) => {
  dispatch(appLoading(true))
  await DB.collection('fishTypes').doc(fishData.id).set(fishData)
  dispatch(appLoading(false))
  dispatch({ type: 'changedDataHandledByListenerAlready' })
}

export const addNewFish = fishData => async(dispatch) => {
  dispatch(appLoading(true))
  DB.collection('fishTypes').add(fishData)
    .then( () => {
      dispatch(appMessage(`{ok}`))
    })
    .catch( err => {
      dispatch(appMessage(`Wystąpił błąd ${"\n"}Błąd systemu to: ${err.message}`))
    })
}

export const deleteFish = fishId => async(dispatch) => {
  dispatch(appLoading(true))
  DB.collection('fishTypes').doc(fishId).get()
    .then(async fishDetail => {
      fishDetail = fishDetail.data()
      await DB.collection('fishTypesDel').add(fishDetail)
      await DB.collection('fishTypes').doc(fishId).delete()
      dispatch(appMessage(`{ok}`))
    })
    .catch( err => {
      dispatch(appMessage(`Wystąpił błąd ${"\n"}Błąd systemu to: ${err.message}`))
    })
}

export const getAddedFishList = () => dispatch => {
  let startTime = new Date()
  startTime.setHours(startTime.getHours() - 12 );

  DB.collection('fishMarket')
  .where("time", ">=", startTime)
  .limit(5)
  .orderBy("time", "desc")
  .onSnapshot(result => {
    result = result.docs.map(r => ({ fishMarketId: r.ref.id, ...r.data() }) )
    dispatch({ type: FISH_ADDED, payload: result })
  })
}



// WEBPACK FOOTER //
// ./src/actions/fishMarketActions.js